import {
  setToken,
  removeToken,
  setSimpleUserInfo,
  removeSimpleUserInfo,
} from "@/utill/auth";
import { getInfo, login, logout } from "@/api/user";
import sha256 from "sha256";

const state = () => ({
  token: "",
  userInfo: "",
  role: "",
});

const getters = {
  // TODO: 안 쓰는 듯
  // getRole: function (state) {
  //   return state.role;
  // },
  // TODO: 안 쓰는 듯
  // getUserInfo: function (state) {
  //   return state.userInfo;
  // },
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo;
  },
  SET_ROLE: (state, role) => {
    state.role = role;
  },
};

const actions = {
  login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      login(userInfo)
        .then((response) => {
          const data = response.data.response;
          console.log(data);
          commit("SET_USERINFO", data);
          commit("SET_ROLE", data.roleId);
          data.userId = userInfo.userId;
          data.userPassword = sha256(userInfo.password);
          setSimpleUserInfo(data);
          setToken(data.accessToken);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      logout()
        .then(() => {
          commit("SET_USERINFO", "");
          commit("SET_ROLE", "");
          commit("SET_USER_MENUS", "");
          commit("SET_USER_MENU_TREE", "");
          removeSimpleUserInfo();
          removeToken();
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // remove token
  resetToken({ commit }) {
    console.log(`try to reset token`);
    return new Promise((resolve) => {
      commit("SET_TOKEN", "");
      commit("SET_ROLE", "");
      removeToken();
      resolve();
    });
  },
  getUserInfo({ commit }) {
    return new Promise((resolve, reject) => {
      console.log(`try to call getInfo api`);
      getInfo()
        .then((response) => {
          const data = response.data.response;
          commit("SET_USERINFO", data);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions,
};
